//@ts-ignore
export const isRNWebView = !!window.ReactNativeWebView
